import React from 'react'

import { Box, Button, Grid, Paper, Typography } from '@material-ui/core'
import { generatePath } from 'react-router-dom'

import useAuthGuest from 'hooks/useAuthGuest'
import useDaiPermissions from 'hooks/useDaiPermissions'

import * as service from 'service'
import constants from 'constants/index'
import { routes } from 'GuestRoutes'
import daiStarIcon from 'images/dai-star-light-blue.svg'
import useStyles from './styles'

const RegistrationMethodStep = () => {
  const classes = useStyles()
  const { organizationSlug } = useAuthGuest()
  const { permitted } = useDaiPermissions()
  const daiAllowed = permitted(constants.dai.solutions.TAGS.AI_INVENTORY)

  const goToManualRegistration = () => {
    service.history.push(
      generatePath(routes.aiInventory.new, { organizationSlug }),
    )
  }

  const goToDaiRegistration = () => {
    service.history.push(
      generatePath(routes.aiInventory.daiNew, { organizationSlug }),
    )
  }

  return (
    <Grid container spacing={4} justifyContent="center">
      <Grid item xs={12}>
        <Typography color="primary" className={classes.title}>
          Cadastrar nova IA
        </Typography>
      </Grid>
      <Grid item xs={12} md={10}>
        <Typography color="primary" className={classes.subtitle}>
          {daiAllowed
            ? `Você ainda não tem nenhuma IA cadastrada. Escolha como deseja
          adicionar as IAs utilizadas ao seu inventário.`
            : `Você ainda não tem nenhuma IA cadastrada. Adicione as IAs
          utilizadas ao seu inventário.`}
        </Typography>
      </Grid>

      {daiAllowed && (
        <Grid item xs={12} md={6}>
          <Paper variant="outlined" className={classes.card}>
            <Box className={classes.cardHeader}>
              <img src={daiStarIcon} alt="DAI" className={classes.cardIcon} />
              <Typography variant="h5" className={classes.cardTitle}>
                Cadastro guiado por IA
              </Typography>
            </Box>
            <Typography variant="body2" className={classes.cardText}>
              Aqui você fará o cadastro de seu inventário de forma{' '}
              <strong>
                facilitada, com a DAI acompanhando, sugerindo e tirando suas
                dúvidas.
              </strong>
            </Typography>
            <Button
              fullWidth
              variant="contained"
              className={`${classes.cardButton} ${classes.daiButton}`}
              onClick={goToDaiRegistration}
            >
              Cadastrar com a DAI
            </Button>
          </Paper>
        </Grid>
      )}

      <Grid item xs={12} md={6}>
        <Paper variant="outlined" className={classes.card}>
          <Box className={classes.cardHeader}>
            <Typography variant="h5" className={classes.cardTitle}>
              Cadastro manual
            </Typography>
          </Box>
          <Typography variant="body2" className={classes.cardText}>
            Aqui você fará o cadastro de seu inventário de forma{' '}
            <strong>
              completamente manual, método bom para quem já é experiente no
              assunto.
            </strong>
          </Typography>
          <Button
            fullWidth
            variant="contained"
            className={`${classes.cardButton} ${classes.manualButton}`}
            onClick={goToManualRegistration}
          >
            Cadastrar manualmente
          </Button>
        </Paper>
      </Grid>
    </Grid>
  )
}

export default RegistrationMethodStep
